import { Instagram } from "lucide-react";
import { Logo } from "./Logo";
import { LEGAL, waLink } from "../lib/constants";

export const FooterLegal = () => (
  <footer data-testid="footer-legal-section" className="bg-slate-950 text-slate-300">
    <div className="mx-auto grid max-w-7xl gap-12 border-t border-white/10 px-5 py-16 sm:px-8 md:grid-cols-4">
      <div>
        <Logo dark />
        <p className="mt-5 max-w-xs text-sm leading-relaxed text-slate-400">
          Projetos de engenharia e arquitetura com rigor técnico e estética atemporal.
        </p>
      </div>

      <div>
        <h3 className="font-mono text-[11px] uppercase tracking-[0.3em] text-slate-500">Escritório</h3>
        <ul className="mt-5 space-y-2 text-sm text-slate-300">
          <li data-testid="footer-razao-social">{LEGAL.razaoSocial}</li>
          <li data-testid="footer-cnpj" className="font-mono text-xs">CNPJ {LEGAL.cnpj}</li>
          <li className="text-slate-400">{LEGAL.address}</li>
        </ul>
      </div>

      <div>
        <h3 className="font-mono text-[11px] uppercase tracking-[0.3em] text-slate-500">Contato</h3>
        <ul className="mt-5 space-y-2 text-sm">
          <li>
            <a data-testid="footer-email" href={`mailto:${LEGAL.email}`} className="transition-colors hover:text-white">
              {LEGAL.email}
            </a>
          </li>
          <li>
            <a
              href={waLink("Olá! Vim pelo site da ZARI ENGENHARIA.")}
              target="_blank"
              rel="noreferrer"
              className="transition-colors hover:text-white"
            >
              WhatsApp {LEGAL.phone}
            </a>
          </li>
          <li>
            <a
              data-testid="footer-instagram-link"
              href={LEGAL.instagram}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 transition-colors hover:text-white"
            >
              <Instagram size={14} strokeWidth={1.8} /> {LEGAL.instagramHandle}
            </a>
          </li>
          <li className="text-slate-400">Seg – Sex, 8h às 18h</li>
        </ul>
      </div>

      <div>
        <h3 className="font-mono text-[11px] uppercase tracking-[0.3em] text-slate-500">Navegação</h3>
        <ul className="mt-5 space-y-2 text-sm">
          <li><a href="/#projetos" className="transition-colors hover:text-white">Nossos projetos</a></li>
          <li><a href="/#servicos" className="transition-colors hover:text-white">Serviços</a></li>
          <li><a href="/#solicitar" className="transition-colors hover:text-white">Solicitar projeto</a></li>
          <li><a href="/#sobre" className="transition-colors hover:text-white">O escritório</a></li>
          <li><a href="/admin" className="transition-colors hover:text-white">Área administrativa</a></li>
        </ul>
      </div>
    </div>

    <div className="border-t border-white/10">
      <div className="mx-auto flex max-w-7xl flex-col gap-2 px-5 py-6 font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500 sm:flex-row sm:items-center sm:justify-between sm:px-8">
        <span>© 2026 {LEGAL.razaoSocial}</span>
        <span>{LEGAL.city} // 24.16° S, 54.10° O</span>
      </div>
    </div>
  </footer>
);
